







































import { Form, FormOption, FormField } from 'inscreva-sse-models';
import { Component, Vue, Prop } from 'vue-property-decorator';

import DynamicFormField from './DynamicFormField.vue';
import DynamicFormOption from './DynamicFormOption.vue';

export type Button = {
  id: string;
  type: 'danger' | 'success';
  icon: string;
};
@Component({
  components: {
    DynamicFormField,
    DynamicFormOption,
  },
})
export default class DynamicFormComponent extends Vue {
  @Prop({ required: true })
  private form!: Form;

  @Prop({ default: false })
  private isEditing!: boolean;

  constructor() {
    super();
  }

  onSearch(params: Record<string, any>) {
    this.$emit('on-search', params);
  }

  onSelect(items: Array<FormOption>) {
    this.$emit('on-select', items);
  }

  onFieldButtonClick({ id }: Button, field: FormField) {
    this.$emit('on-field-button-click', { id, field });
  }
}
